export default __webpack_public_path__ + "static/media/evoBTC.5ec1dd05.svg";